export default __webpack_public_path__ + "static/media/diamond.9291a048.wav";